import { render, staticRenderFns } from "./ESGInstitutions.vue?vue&type=template&id=e36cd884&scoped=true"
import script from "./ESGInstitutions.vue?vue&type=script&lang=js"
export * from "./ESGInstitutions.vue?vue&type=script&lang=js"
import style0 from "./ESGInstitutions.vue?vue&type=style&index=0&id=e36cd884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36cd884",
  null
  
)

export default component.exports